import { Alert, Box, Button, Divider, Switch, Tooltip, Typography } from "@mui/material";
import { DaymapIcon, DaymapIconType, PullActionHandler, RecordListControls, RecordListDropDown, RecordsList, useStudent, useAppState, useAuth } from "daymap-react";
import { useRef} from "react";
import { useNavigate, useParams} from "react-router-dom";
import AddIcon from '@mui/icons-material/Add';
import { PageContainer, PageDescriptor } from "../../../components/layout";


type RecordsState = {
    includeExpired: boolean;
    form: Form;
}

type Form ={
    formId:number;
    CanAdd: boolean;
    Expires: boolean;
}

function Records() {
    const { studentId } = useParams();
    //const [searchParams] = useSearchParams();
    //const [form, setForm] = useState<{ formId: number; CanAdd: boolean, Expires:boolean }>({formId:0, CanAdd:false, Expires:false});
    const navigate = useNavigate();
    const listRef = useRef<RecordListControls>(null);
    const student = useStudent(Number(studentId));
    const {IsImpersonating} = useAuth();
    const [state, setState] = useAppState<RecordsState>("IncludeExpiredForms", {includeExpired: false, form: {formId:0, CanAdd: false, Expires: false}}, "session");

    const onExpiredChange = (val:boolean) =>{
        setState({...state, includeExpired: val})
    }
    const setForm = (newForm: Form) =>{
        setState({...state, form: newForm})
    }
    return (
        <PageContainer>
            <PageDescriptor icon={<DaymapIcon iconType={DaymapIconType.Record} />} title="Records">
                View records for {student?.Displayname}
            </PageDescriptor>  
            {IsImpersonating && <Alert severity="warning" variant="outlined" sx={{marginBottom: 2}}>Changes to records cannot be made while impersonating</Alert> }
            {listRef.current && <PullActionHandler onPullComplete={listRef.current!.refetch}/>}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1, flexWrap: 'wrap', pb: 2, paddingRight:2 }}>
                <RecordListDropDown studentId={Number(studentId)} onChange={setForm} selected={state.form.formId} includeExpired={state.includeExpired} year={new Date().getFullYear()}/>
                { state.form.Expires &&
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, pt: 2 }}>
                    <Switch
                        size="small"
                        checked={state.includeExpired}
                        onChange={(e) => onExpiredChange(e.target.checked)}
                    />
                    <Typography>Show Expired</Typography>
                </Box>}
                <Tooltip
                    title="Cannot create new records while impersonating"
                    disableHoverListener={!IsImpersonating}
                    disableFocusListener={!IsImpersonating}
                    disableTouchListener={!IsImpersonating}
                >
                    <span>
                        <Button variant="contained" startIcon={<AddIcon />} disabled={IsImpersonating || !state.form.CanAdd} href={`./${state.form.formId}`}>New</Button>
                    </span>
                </Tooltip>
            </Box>  
            <Divider/>
            <br/>
            {state.form.formId == 0 ? <Alert severity="info" >Please select a form</Alert> : <></>}
            <RecordsList ref={listRef} formId={state.form.formId} studentId={Number(studentId)} canAdd={state.form.CanAdd} onClick={(ret:any) => navigate(String(ret))} includeExpired={state.includeExpired}  year={new Date().getFullYear()}/>
        </PageContainer>
    )
}

export default Records;